import React, { Component } from "react";
import * as d3 from "d3";
import $ from "jquery";
import moneyFormatter from "../../common/moneyFormatter";

import "./groupBarWithLine.style.scss";

class GroupBarWithLine extends Component {
  state = {
    data: [],
    linechartData: [],
    margin: { top: 20, right: 20, bottom: 30, left: 40 },
    barColors: [
      "#E9E26E",
      "#C2DB72",
      "#9ED27A",
      "#7EC785",
      "#63BB8E",
      "#4FAD96",
      "#479E99",
      "#498F98",
      "#517F92"
    ],
    bgColors: ["#ff220033", "#fff70033", "#0059ff33", "#e85fa594"]
  };

  componentWillMount() {
    this.modifyData(this.props);
  }

  componentDidMount() {
    this.displayChart(this.props);
  }

  componentWillReceiveProps(nextProps) {
    // if (
    //   JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data) ||
    //   this.props.width !== nextProps.width
    // ) {
      this.modifyData(nextProps);
      setTimeout(() => this.displayChart(nextProps), 0);
    // }
  }

  modifyData = props => {
    // divide data into 3 parts
    let { data, labels } = props;

    const listNumber = num => {
      let a, b, c;
      a = Math.floor(num / 3);
      b = a;
      c = num - (a + b);
      return [a, b, c];
    };
    let list = listNumber(data.length);

    let newData = [];
    let obj = {};
    let end = 0;
    let initial = 0;
    for (let a = 0; a < list.length; a++) {
      end = end + list[a];

      let x = 0;
      for (let i = initial; i < end; i++) {
        obj[`rect ${x}`] = data[i]["investment"];
        x++;
      }
      initial = initial + list[a];
      obj["Label"] = labels[a];
      newData.push(obj);
      obj = {};
    }

    this.setState({ data: newData, linechartData: data });
  };
  displayChart = props => {
    const { id, width, labels } = props;
    const { linechartData, margin, barColors, bgColors, data } = this.state;

    const baseData = this.props.data;

    $(`#${id}`).empty();
    if (!data.length) return;

    var w = width - margin.left - margin.right,
      height = 500 - margin.top - margin.bottom;

    var x0 = d3.scale.ordinal().rangeRoundBands([0, w], 0.01);
    var x1 = d3.scale.ordinal();

    var axisYear = d3.scale
      .linear()
      .range([0, w])
      .domain(d3.extent(baseData.map(d => d.year)));

    var y = d3.scale.linear().range([height, 0]);

    var color = d3.scale.ordinal().range([...barColors]);

    var xAxis = d3.svg
      .axis()
      .scale(axisYear)
      .orient("bottom")
      .tickFormat(d3.format(".2"));

    var yAxis = d3.svg
      .axis()
      .scale(y)
      .orient("left")
      .tickFormat(d3.format(".2s"));

    var svg = d3
      .select(`#${id}`)
      .append("svg")
      .attr("width", w + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    var ageNames1 = d3.keys(data[0]).filter(function(key) {
      return key !== "Label";
    });
    var ageNames2 = d3.keys(data[1]).filter(function(key) {
      return key !== "Label";
    });
    var ageNames3 = d3.keys(data[2]).filter(function(key) {
      return key !== "Label";
    });

    data.forEach(function(d, i) {
      d.ages = ageNames3
        .map(function(name) {
          if (d[name]) return { name: name, value: d[name] * 1 };
        })
        .filter(d => d);
    });

    x0.domain(
      data.map(function(d) {
        return d.Label;
      })
    );
    x1.domain(ageNames3).rangeRoundBands([0, x0.rangeBand()]);
    y.domain([
      0,
      d3.max(data, function(d) {
        return d3.max(d.ages, function(d) {
          return d.value;
        });
      })
    ]);

    svg
      .append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis);

    // var xAxis_year = d3.svg
    //   .axis()
    //   .scale(axisYear)
    //   .orient("bottom");
    // svg
    //   .append("g")
    //   .attr("class", "x axis")
    //   .attr("transform", "translate(0," + height + ")")
    //   .call(xAxis_year);

    svg
      .append("g")
      .attr("class", "y axis")
      .call(yAxis);

    // adding rect to individual bar group parent
    var state2 = svg
      .selectAll(".containerRect")
      .data(data)
      .enter()
      .append("g")
      .attr("class", "containerRect")
      .attr("transform", function(d) {
        return "translate(" + x0(d.Label) + ",0)";
      });

    state2
      .append("rect")
      .attr("width", function(d, i) {
        return x1.rangeBand() * d["ages"].length;
      })
      .attr("height", function(d) {
        return height;
      })
      .style("fill", (d, i) => bgColors[i]);

    state2
      .append("text")
      .attr("x", 5)
      .attr("y", 20)
      .text((d, i) => labels[i])
      .attr("class", "rectangle_label");

    var state = svg
      .selectAll(".rectangle_group")
      .data(data)
      .enter()
      .append("g")
      .attr("class", "rectangle_group")
      .attr("transform", function(d) {
        return "translate(" + x0(d.Label) + ",0)";
      });

    state
      .selectAll("rect")
      .data(function(d) {
        return d.ages;
      })
      .enter()
      .append("rect")
      .attr("width", x1.rangeBand())
      .attr("x", function(d) {
        return x1(d.name);
      })
      .attr("y", function(d) {
        return y(d.value);
      })
      .attr("height", function(d) {
        return height - y(d.value);
      })
      .style("fill", function(d) {
        return color(d.name);
      })
      .append("title")
      .text(d => moneyFormatter(d.value));

    // **** line chart ****

    var x = d3.time.scale().range([40, w - 40]);

    // Parse the year / time
    // var parseDate = d3.time.format("%d-%b-%y").parse;

    // Define the line
    var valueline = d3.svg
      .line()
      .interpolate("linear")
      .x(function(d) {
        return x(d.year);
      })
      .y(function(d) {
        return y(d.investment);
      });

    linechartData.forEach(function(d) {
      d.year = d.year;
      d.investment = +d.investment;
    });

    // Scale the range of the data
    x.domain(
      d3.extent(linechartData, function(d) {
        return d.year;
      })
    );

    // Add the valueline path.
    svg
      .append("path") // Add the valueline path
      .attr("d", valueline(linechartData))
      .style("fill", "none")
      .style("stroke", "#565656")
      .style("stroke-dasharray", "2px")
      .style("stroke-width", "1px");

    svg // Add the valueline path.
      .selectAll("circle")
      .data(linechartData)
      .enter()
      .append("circle")
      .attr("r", 4)
      .attr("cx", d => x(d.year))
      .attr("cy", d => y(d.investment))
      .attr("class", "line_circles")
      .append("title")
      .text(data => `${data.year} : ${moneyFormatter(data.investment)}`);
  };
  render() {
    const { id } = this.props;
    return <div id={id} />;
  }
}

export default GroupBarWithLine;



// WEBPACK FOOTER //
// ./src/components/d3Components/groupBarWithLineChart/groupBarWithLine.jsx